import React, { useEffect, useState } from "react";
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import FacebookIcon from '@mui/icons-material/Facebook';

import { Global } from "@emotion/react";
import { emotionGlobalCss } from "./styles";
import { Box } from "@mui/material";

//import "./facebookWidget.css";

declare global {
  interface Window {
    FB: any;
  }
}

const FacebookWidget=(props:any)=>{
  const {position} = props;
  const [state, setState] = useState(0);

  const initScript = () => {
    window.FB?.init({
      appId: '626235684525946', // App ID
      cookie: true, // enable cookies to allow the server to access the session
      xfbml: true,  // parse XFBML
      version: 'v2.10'
    });
  };


  const Script = function () {
    var js, fjs = document.getElementsByTagName('script')[0];
    if (document.getElementById('facebook-jssdk')) return;
    js = document.createElement('script');
    js.id = 'facebook-jssdk';
    js.async = true;
    js.type = "text/javascript"
    js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v14.0&appId=962924500474594&autoLogAppEvents=1";
    fjs.parentNode?.insertBefore(js, fjs);
  }


  useEffect(() => {
    if (state > 0) { initScript(); }
    else {
      Script();
      setState(state + 1);
    }
  });

  return (
    (position === "static") && <>
    <Global styles={emotionGlobalCss} />
    <Box className="widgetContainer" sx={{zIndex:"9999999"}} >
      <div className="facebookWidget" >
        <OutboundLink className="facebookSquareIcon1" href="https://www.facebook.com/andmarecoenergy">
            <span> <FacebookIcon sx={{top: "-4.5px", width: "76.5px !important"}} /> </span>
          </OutboundLink>

        {/* <div className="fb-like" data-href="https://www.facebook.com/andmarecoenergy" data-width="250" data-layout="standard" data-action="like" data-size="large" data-share="true"></div> */}
        <div className="fbIconBackground"></div>
        {/* <div className="fb-page" data-href="https://www.facebook.com/andmarecoenergy/" data-tabs="timeline" data-width="272" data-height="70" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="true"><blockquote cite="https://www.facebook.com/andmarecoenergy/" className="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/andmarecoenergy/">Andmar Eco-Energy</a></blockquote></div> */}
        <iframe src={`https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fandmarecoenergy%2F&tabs=timeline&width=280&height=70&small_header=true&adapt_container_width=false&hide_cover=true&show_facepile=false&appId=962924500474594`} width="280" height="70" style={{border:"none",overflow:"hidden"}} scrolling="no" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
      </div>
    </Box>
    </>
  )

};

export default React.memo(FacebookWidget);




